const EDIT_APP_GIFTICON_COMPANY_ORDER_DRAFT_PREFIX = 'admin:appGifticonCompanyOrderDraft:edit:'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizePayStatusValue = (value, fallbackValue = 'ready') => {
    if (!value) {
        return fallbackValue
    }

    return String(value)
}

// 기프티콘 무통장입금 주문 상세는 운영자가 다시 선택해야 하는 주문상태만 sessionStorage에 남긴다.
export const createAppGifticonCompanyOrderDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            payStatus: normalizePayStatusValue(params.payStatus, 'ready'),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 상태 검토 흐름을 이어간다.
export const applyAppGifticonCompanyOrderDraft = ({ baseParams = {}, draft }) => {
    const normalizedBaseDraft = createAppGifticonCompanyOrderDraftPayload({
        params: baseParams,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            payStatus: draftParams.payStatus === undefined
                ? normalizedBaseDraft.params.payStatus
                : normalizePayStatusValue(draftParams.payStatus, normalizedBaseDraft.params.payStatus),
        }
    }
}

export const createEditAppGifticonCompanyOrderDraftKey = (paymentId) => `${EDIT_APP_GIFTICON_COMPANY_ORDER_DRAFT_PREFIX}${paymentId}`

export const readAppGifticonCompanyOrderDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppGifticonCompanyOrderDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 검토 흐름은 그대로 유지한다.
    }
}

export const clearAppGifticonCompanyOrderDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
